module.exports = __webpack_public_path__ + "img/file-heart-03.08a62b22.svg";